// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"592":"common","966":"dashboard"}[chunkId] || chunkId) + "." + {"324":"d79220b1","361":"b342000a","592":"98ecb441","966":"3eb35c91"}[chunkId] + ".js";
};